export function NextIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 12.0031C24 18.6135 18.6164 24 11.9969 24C5.38364 24 0 18.6135 0 12.0031C0 5.38364 5.38364 0 11.9969 0C18.6164 0 24 5.38364 24 12.0031ZM12.252 7.87616C12.252 8.1522 12.3646 8.41721 12.573 8.59823L14.3752 10.3193L15.2173 10.9935L13.4662 10.9018H6.99535C6.41049 10.9018 5.92106 11.3859 5.92106 11.994C5.92106 12.5932 6.41049 13.0831 6.99535 13.0831H13.4662L15.2235 12.9975L14.3752 13.6718L12.573 15.3928C12.3646 15.5738 12.252 15.845 12.252 16.121C12.252 16.6392 12.6358 17.0716 13.1763 17.0716C13.4647 17.0716 13.6699 16.9647 13.8632 16.7652L17.6769 12.8263C17.9468 12.5416 18.0446 12.2816 18.0446 11.994C18.0446 11.7004 17.9468 11.4404 17.6769 11.1557L13.8632 7.2229C13.6699 7.02344 13.4647 6.91654 13.1763 6.91654C12.6358 6.91654 12.252 7.36419 12.252 7.87616Z"
        fill="currentColor"
      />
    </svg>
  )
}
